import { render } from "./TMDF42.vue?vue&type=template&id=5b7da6e9&scoped=true"
import script from "./TMDF42.vue?vue&type=script&lang=js"
export * from "./TMDF42.vue?vue&type=script&lang=js"

import "./TMDF42.vue?vue&type=style&index=0&id=5b7da6e9&scoped=scoped&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7da6e9"]])

export default __exports__